import { render, staticRenderFns } from "./voteDetails.vue?vue&type=template&id=79716c94&scoped=true"
import script from "./voteDetails.vue?vue&type=script&lang=js"
export * from "./voteDetails.vue?vue&type=script&lang=js"
import style0 from "./voteDetails.vue?vue&type=style&index=0&id=79716c94&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79716c94",
  null
  
)

export default component.exports